module.exports = __webpack_public_path__ + "static/media/produce@3x.cd183655.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/produce@3x.png
// module id = 782
// module chunks = 1